import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const DeleteAssistantConfirmDialog = ({ open, onClose, onConfirm }) => {
  const [deleteLocal, setDeleteLocal] = React.useState(true);
  const [deleteOpenAI, setDeleteOpenAI] = React.useState(false);

  const handleConfirm = () => {
    onConfirm({ deleteLocal, deleteOpenAI });
    handleClose();
  };

  const handleClose = () => {
    setDeleteLocal(true);
    setDeleteOpenAI(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{i18n.t("assistant.deleteModal.title")}</DialogTitle>
      <DialogContent>
        <p>{i18n.t("assistant.deleteModal.message")}</p>
        <FormControlLabel
          control={
            <Checkbox
              checked={deleteLocal}
              onChange={(e) => setDeleteLocal(e.target.checked)}
            />
          }
          label={i18n.t("assistant.deleteModal.local")}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={deleteOpenAI}
              onChange={(e) => setDeleteOpenAI(e.target.checked)}
            />
          }
          label={i18n.t("assistant.deleteModal.openai")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="default">
          {i18n.t("assistant.deleteModal.cancel")}
        </Button>
        <Button onClick={handleConfirm} color="secondary" variant="contained">
          {i18n.t("assistant.deleteModal.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAssistantConfirmDialog;
